import React, { useEffect, useState, useCallback, useMemo } from "react";
import CustomTable from "src/components/App/AppGrid/CustomTable/CustomTable";
import { Avatar, Chip, Box, alpha, DialogContent, Typography } from "@mui/material";
import theme from "src/config/theme";
import ButtonComponent from "src/components/shared/Button";
import DialogBox from "src/components/shared/Dialog/DialogBox";
import NotesTabForm from "../Forms/NotesTabForm";
import { ReactComponent as Edit } from '../../../../../assets/images/edit-2.svg';
import { ReactComponent as Delete } from '../../../../../assets/images/trash.svg';
import { ReactComponent as Add } from '../../../../../assets/images/add-square.svg';
import NoDataFound from "../../NoDataFound/NoDataFound";
import { useDispatch, useSelector } from "react-redux";

import { getMedicalRecordsRequest, deleteMedicalRecordRequest } from "src/modules/app/store/appActions";
import NotesCard from "../CardView/NotesCard";
import DeleteDialog from "../../DeleteDialog";
import useResponsive from "src/components/hooks/useResponsive";
import useAppointmentDetails from "../../UseAppointmentDetails";
import { AllTabsMainContainer } from "../Style";
import dayjs from "dayjs";
const columns = [
    { id: "note", label: "Notes", sx: { width: "1200px", minWidth: "150px", textAlign: 'left' } },
    { id: "addedDate", label: "Added Date", sx: { "& .css-axw7ok": { justifyContent: 'center' } } },
];
const Notes = ({ shouldRefresh }) => {

    const dispatch = useDispatch();
    const [notes, setNotes] = useState([]);
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteNoteId, setDeleteNoteId] = useState(null);
    const { isMobile, isTablet, isDesktop } = useResponsive();
    const [page, setPage] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState();
    const handleOpenDeleteDialog = (notesId) => {
        setDeleteNoteId(notesId);
        setOpenDeleteDialog(true);
    };
    const handleCloseDeleteDialog = () => setOpenDeleteDialog(false);
    const { PatientId } = useAppointmentDetails();


    const fetchNotes = useCallback(
        (page = 0, perPage = 10) => {
            const fetchData = async () => {
                const params = {
                    page: page + 1,
                    limit: perPage,
                };

                const response = await new Promise((resolve, reject) => {
                    dispatch(getMedicalRecordsRequest({ patientId: PatientId, params }, resolve, reject));
                });

                if (response?.data && response?.meta) {
                    const filteredData = response.data.filter(note => note.recordType === 'note');
                    setNotes(filteredData);
                    setTotalCount(response.meta.totalRecords);
                    console.log("Fetched notes:", filteredData);
                } else {
                    console.log('Error fetching notes');
                }

            }
            fetchData();

        },
        [dispatch, PatientId],
    );

    useEffect(() => {
        if (PatientId) {
            fetchNotes(page, perPage);
        }
    }, [PatientId, fetchNotes, page, perPage, shouldRefresh]);


    const handleDelete = async (notesId) => {
        if (notesId) {
            try {
                const response = await dispatch(deleteMedicalRecordRequest(notesId));
                setNotes((prevNotes) => prevNotes.filter(note => note.id !== notesId));
                setOpenDeleteDialog(false);
                console.log('Note deleted successfully');
            } catch (error) {
                console.error('Failed to delete note:', error);
            }
        }
    };
    const actions = [
        // { label: "Delete", icon: <Delete />, onClick: (row) => handleOpenDeleteDialog(row.notesId) },
    ];
    const data = notes.map((notesData) => ({
        notesId: notesData?.id,
        note: notesData?.notes,
       addedDate: `${dayjs(notesData.date).format("DD-MM-YYYY")}, ${notesData.time}`,

        // addedBy: 'John Doe',
    }))

    return (
        <>
            <AllTabsMainContainer>
                {(isMobile || isTablet) ?
                    <NotesCard
                        notes={notes}
                        page={page}
                        perPage={perPage}
                        setPage={setPage}
                        totalCount={totalCount}
                        fetchNotes={fetchNotes}
                    /> :
                    <CustomTable
                        key={page}
                        columns={columns}
                        data={data}
                        actions={actions}
                        disabled={true}
                        page={page}
                        onPageChange={(newPage) => {
                            setPage(newPage);
                        }}
                        onPerPageChange={(newPerPage) => {
                            setPerPage(newPerPage);
                            setPage(0);
                        }}
                        perPage={perPage}
                        totalCount={totalCount}
                        headerButton={
                            <ButtonComponent
                                variant="contained"
                                endIcon={<Add width={isMobile || isTablet ? 18 : 24}
                                    height={isMobile || isTablet ? 18 : 24} />}
                                onClick={handleOpen}
                                sx={{
                                    background: theme.palette.primary.main,
                                    border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
                                    boxShadow: theme.shadows[1],
                                    width: '122px',
                                    height: '36px',
                                    padding: '6px 6px 6px 10px',
                                    borderRadius: '12px',
                                    ...theme.typography.h5,
                                }}
                            >Add Note</ButtonComponent>
                        }
                        noDataComponent={
                            <NoDataFound
                                title="No Notes Found!"
                                buttonText="Add Note"
                                buttonIcon={Add}
                                onClick={handleOpen}
                            />
                        }
                    />}


                <DialogBox open={open} onClose={handleClose} >
                    <NotesTabForm onClose={handleClose} fetchNotes={fetchNotes} />
                </DialogBox>

                <DeleteDialog
                    open={openDeleteDialog}
                    onClose={handleCloseDeleteDialog}
                    onConfirm={handleDelete}
                    idToDelete={deleteNoteId}
                    title="Delete Note"
                    message="Are you sure you want to delete this note?"
                    confirmText="Delete"
                />
            </AllTabsMainContainer>
        </>
    )
};

export default Notes;

